const RestClient = {

    url: (function () {
        if(process.env.NODE_ENV === 'development')
            return 'https://www.eshopping.de/'

        return ''
    })(),

    install(Vue) {
        Vue.prototype.$RestClient = this
        Vue.RestClient = this
    },

    login (invoiceNumber, postalCode) {

        return fetch(this.url + '/servicecenter/signin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({invoicenumber:invoiceNumber, postalcode:postalCode})
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                return response;
            })
    },

    checkLoginStatus () {
        return fetch(this.url + '/servicecenter/checklogin', {
            method: 'GET',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                return response;
            })
    },

    logout () {
        return fetch(this.url + '/servicecenter/logout', {
            method: 'GET',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json()
            })
    },

    loadOrders (contactID) {

        return fetch(this.url + '/servicecenter/getorders', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({contactID})
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                return response;
            })
    },

    getVariationImage (variationId) {

        let imageurl = String

        let xhr = new XMLHttpRequest();
        xhr.open("GET", this.url + '/servicecenter/variationimage/?variationId=' + variationId, false);
        xhr.withCredentials = true;

        xhr.onreadystatechange = function() {

            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {

                imageurl = JSON.parse(xhr.responseText) ;
            }
        };

        xhr.send();

        return imageurl
    },
    
    sendMail2Service (formdata) {

        return fetch(this.url + '/servicecenter/sendservicemail', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({data: formdata})
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                return response;
            })
    },

    getReturnLabel (orderId, customerId, code) {

        return fetch(this.url + '/servicecenter/makereturnlabel', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({orderId:orderId, customerId:customerId, code:code})
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                return response;
            })
    },

    getInvoiceDocument (orderId) {

        return fetch(this.url + '/servicecenter/getinvoicedocument', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({orderId:orderId})
        })
            .then(response => response.json())
            //.then(response => response.find(x => x.type === 'invoice')['path'] || false)
    }
}

export default RestClient;


